import React from 'react';
import { debounce } from '../../../utils/throttle';
const TAB_TYPE = [{
  id: 'introduction',
  text: '介绍'
},{
  id: 'comments',
  text: '评价'
},{
  id: 'nextStation',
  text: '下一站'
}];

const TAB_TYPE2 = [{
  id: 'introduction',
  text: '介绍'
},{
  id: 'nextStation',
  text: '下一站'
}];


export default function TabType(props){
  let { tabType, changeTab, showComment } = props;
  let tabList = showComment ? TAB_TYPE : TAB_TYPE2;
  return(
    <div className={`header-type ${showComment ? 'poi' : 'other'}`}>
      {
        tabList.map((tab,index)=>{
          return(
            <div 
              key={index}
              className={tab.id === tabType ? 'type-item active' : 'type-item'}
              onClick={()=>{
                debounce(changeTab(tab.id),10);
              }}>
              {tab.text}
            </div>
          );
        })
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Poi2/TabType/index.js